import { apiClient } from './api-client';
import URI from 'urijs';
import { ShoppingCartItemAnalytics } from '@/entities/analytics/ShoppingCartItemAnalytics';

/**
 * Service to retrieve analytics data.
 */
export class AnalyticsService {
    private get baseUrl(): URI {
        return new URI('/api/analytics');
    }

    public async getMultipleShoppingCartItemAnalytics(
        shoppingCartItemAnalyticsRequests: Array<{ partId: string; quantity: number }>
    ): Promise<ShoppingCartItemAnalytics[]> {
        const query = shoppingCartItemAnalyticsRequests.reduce(
            (prev, cur, i) => ({
                ...prev,
                [`requests[${i}].partId`]: cur.partId,
                [`requests[${i}].quantity`]: cur.quantity,
            }),
            {}
        );

        const res = await apiClient.get<ShoppingCartItemAnalytics[]>(
            this.baseUrl
                .segmentCoded('shopping-cart-items')
                .addQuery(query)
                .toString()
        );

        return res.data;
    }

    public async getShoppingCartItemAnalytics(
        partId: string,
        quantity: number
    ): Promise<ShoppingCartItemAnalytics | null> {
        const res = await this.getMultipleShoppingCartItemAnalytics([{ partId, quantity }]);

        if (res.length !== 1) {
            return null;
        }

        return res[0];
    }
}
